export default __webpack_public_path__ + "static/2184-d3c0c460672cff423e7e062a7bd358fc.gif";